.coach {
  position: fixed;
  inset: 0;
  z-index: 12;
  display: flex;
  align-items: flex-start;
  padding: 94px 16px 16px;
  pointer-events: none;
}

.card {
  position: relative;
  width: min(340px, calc(100vw - 32px));
  padding: 14px 16px 12px;
  background: #fffaf3;
  pointer-events: none;
}

.heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  color: var(--accent);
  font-size: 12px;
  font-weight: 700;
}

.page {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

/* Leaving the lesson: a link by the page number, out of the way of going on. */
.skip {
  padding: 2px 0;
  border: none;
  background: none;
  color: var(--ink-soft);
  font: inherit;
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  pointer-events: auto;
}

.skip:hover {
  color: var(--ink);
}

.card h2 {
  margin: 12px 0 10px;
  font-size: 17px;
}

.card p {
  margin: 0 0 10px;
  font-size: 13px;
  line-height: 1.55;
  color: var(--ink-soft);
}

.practice {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  padding: 8px 10px;
  border-radius: 10px;
  background: rgba(122, 86, 68, 0.07);
  font-size: 12px;
  font-weight: 700;
}

.practice svg {
  width: 24px;
  height: 24px;
  color: var(--accent);
}

.practice b {
  margin-left: 4px;
  font-variant-numeric: tabular-nums;
}

.card p.advice {
  margin-bottom: 10px;
  padding: 8px 10px;
  border-radius: 10px;
  background: #fbe3d6;
  color: var(--ink);
  font-size: 12px;
  font-weight: 700;
}

.actions {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.actions button {
  min-height: 36px;
  padding: 7px 12px;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  pointer-events: auto;
}

.actions button:last-child {
  margin-left: auto;
  border-color: #c8693f;
  background: #d9774f;
  color: #fff;
}

.actions button:disabled {
  border-color: var(--line);
  background: #eee8df;
  color: var(--ink-soft);
  cursor: default;
}

:global(.judged) .coach {
  display: none;
}

@media (max-width: 640px) {
  .coach {
    padding: 80px 10px 10px;
  }

  .card {
    width: min(320px, calc(100vw - 20px));
    padding: 12px 13px 10px;
    transform-origin: top left;
    transition: transform 0.25s ease, opacity 0.2s ease;
  }

  /* Shrunk into the button left where it was. */
  .away .card {
    transform: scale(0.4);
    opacity: 0;
    /* Out of reach once shrunk, its buttons too. */
    visibility: hidden;
    transition: transform 0.25s ease, opacity 0.2s ease, visibility 0s 0.25s;
  }

  .away .reopen {
    display: flex;
    animation: reopen-in 0.25s ease 0.1s both;
  }
}

@keyframes reopen-in {
  from {
    transform: scale(0.8);
    opacity: 0;
  }
}

/* What the card shrinks into: a pill with the step, at the card's top left. */
.reopen {
  position: absolute;
  top: 80px;
  left: 10px;
  display: none;
  align-items: center;
  gap: 6px;
  max-width: min(240px, calc(100vw - 150px));
  padding: 7px 14px 7px 10px;
  border: 1.5px solid var(--accent);
  border-radius: 99px;
  background: #fffaf3;
  box-shadow: 0 4px 12px rgba(120, 80, 50, 0.15);
  font: inherit;
  font-size: 12px;
  color: var(--ink);
  cursor: pointer;
  pointer-events: auto;
}

.reopen svg {
  flex: none;
  width: 18px;
  height: 18px;
  color: var(--accent);
}

.reopen b {
  flex: none;
  color: var(--accent);
  font-variant-numeric: tabular-nums;
}

.reopen span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
}
